<template>
  <div>
    <v-dialog
      v-for="modal in modalStore.modals"
      :key="modal.id"
      :model-value="modal.isOpen"
      :width="modal.options.width"
      :max-width="modal.options.maxWidth"
      :persistent="modal.options.persistent"
      :scrollable="modal.options.scrollable"
      :fullscreen="modal.options.fullscreen"
      :transition="modal.options.transition"
      @update:model-value="handleDialogClose(modal.id, $event)"
    >
      <v-card>
        <v-toolbar v-if="modal.options.title" dense flat>
          <v-toolbar-title>{{ modal.options.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="modalStore.dismissModal(modal.id)">
            <v-icon :icon="mdiClose"></v-icon>
          </v-btn>
        </v-toolbar>
        <component
          :is="modal.component"
          v-bind="modal.props"
          @close="(result) => modalStore.closeModal(modal.id, result)"
          @dismiss="(reason) => modalStore.dismissModal(modal.id, reason)"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { useModalStore } from '@/core/stores/modal.ts'
import { mdiClose } from '@mdi/js'

const modalStore = useModalStore()

const handleDialogClose = (modalId: string, isOpen: boolean) => {
  const modal = modalStore.modals.find((m) => m.id === modalId)
  if (!isOpen && modal && !modal.isClosing) {
    modalStore.dismissModal(modalId)
  }
}
</script>
